define('view/people/external.associations.list.view',['require','exports','module','underscore','uikit/uikit','blockit','fukit/fukit','backbone.radio','fukit/fukit','fukit/fukit','behavior/show.detail.on.table.row.double.press.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      UIKit       = require('uikit/uikit'),
      BlocKit     = require('blockit'),
      RouteHelper = require('fukit/fukit').RouteHelper,
      Radio       = require('backbone.radio');

  //Behaviors
  //prettier-ignore
  var NavigateOnEventBehavior                 = require('fukit/fukit').NavigateOnEventBehavior,
      ConfirmModelDestroyOnPressBehavior      = require('fukit/fukit').ConfirmModelDestroyOnPressBehavior,
      ShowDetailOnTableRowDoublePressBehavior = require('behavior/show.detail.on.table.row.double.press.behavior');

  var DETAIL_ROUTE_NAME = 'externalassociations:detail';

  var ExternalAssociationsView = UIKit.ItemView.extend({
    template: 'external.associations.list.view',

    internalViewOptions: {
      headerTextView: function() {
        return {
          text: 'External Associations',
        };
      },
      tableView: function() {
        var EXTERNAL_ASSOCIATION_COLUMNS = [
          {
            childView: BlocKit.EllipsisColumnView,
            childViewOptions: {
              resolveOptions: {
                components: [
                  {
                    text: 'View',
                    icon: 'pencil',
                    behaviors: {
                      NavigateOnEventBehavior: {
                        behaviorClass: NavigateOnEventBehavior,
                        model: '@this.model',
                        routeName: DETAIL_ROUTE_NAME,
                      },
                    },
                  },
                ],
              },
            },
            collapsing: true,
          },
          {
            text: 'Organization',
            data: 'relationships.organization.name',
          },
          {
            text: 'Title',
            data: 'title',
          },
        ];

        return {
          columns: EXTERNAL_ASSOCIATION_COLUMNS,
          collection: this.collection,
          selectable: true,
          basic: true,
          borderless: true,
          tabletStackable: true,
          behaviors: {
            rowDoublePressBehavior: {
              behaviorClass: ShowDetailOnTableRowDoublePressBehavior,
              doublePressOptions: {
                routeName: DETAIL_ROUTE_NAME,
                params: [
                  {
                    paramName: 'id',
                    paramAttribute: 'id',
                  },
                ],
              },
            },
          },
        };
      },
    },

    intialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);
    },

    onTableViewRowAction: function(table, row, action) {
      var actionName = action.get('action');
      if (actionName) {
        this.trigger('item:' + actionName, row.model);
      }
    },
  });

  module.exports = ExternalAssociationsView;
});

